export const handleErrors = (errors) => {
    const responseErrors = errors.response.data.errors;

    const formattedErrors = {};

    responseErrors && Object.keys(responseErrors).map(item => {
        return formattedErrors[item] = responseErrors[item][0];
    });

    return formattedErrors;
}